import api from './api';

export interface Ruta {
  codigoRuta?: number;
  nombreRuta?: string;
  sincronizar?: number;
}

export interface RutaSearchParams {
  searchTerm?: string;
  pageNumber?: number;
  pageSize?: number;
}

export interface RutaPagedResult {
  items: Ruta[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

const rutaService = {
  getRutas: async (params?: RutaSearchParams): Promise<Ruta[]> => {
    const resp = await api.get('/api/Rutas', params ? { params } : {});
    const data = resp.data;
    if (Array.isArray(data)) return data as Ruta[];
    if (data && typeof data === 'object' && 'items' in data) {
      return data.items as Ruta[];
    }
    return [];
  },

  getRutasPaged: async (params: RutaSearchParams): Promise<RutaPagedResult> => {
    const resp = await api.get('/api/Rutas', { params });
    const data = resp.data;
    
    if (Array.isArray(data)) {
      return {
        items: data,
        totalCount: data.length,
        pageNumber: params.pageNumber || 1,
        pageSize: params.pageSize || 10,
        totalPages: Math.ceil(data.length / (params.pageSize || 10))
      };
    }
    
    if (data && typeof data === 'object' && 'items' in data) {
      return data as RutaPagedResult;
    }
    
    return {
      items: [],
      totalCount: 0,
      pageNumber: params.pageNumber || 1,
      pageSize: params.pageSize || 10,
      totalPages: 0
    };
  },
  
  getRuta: async (codigoRuta: number): Promise<Ruta> => {
    const resp = await api.get(`/api/Rutas/${codigoRuta}`);
    return resp.data as Ruta;
  },

  createRuta: async (ruta: Ruta): Promise<Ruta> => {
    const response = await api.post<Ruta>('/api/Rutas', ruta);
    return response.data;
  },

  updateRuta: async (codigoRuta: number, ruta: Ruta): Promise<void> => {
    await api.put(`/api/Rutas/${codigoRuta}`, ruta);
  },

  deleteRuta: async (codigoRuta: number): Promise<void> => {
    await api.delete(`/api/Rutas/${codigoRuta}`);
  }
};

export default rutaService;

